module.exports = __webpack_public_path__ + "static/media/sign2.0bda3c80.jpg";